export type MenuItem = {
  label: string;
  path: string;
  internal: boolean;
};

export const whoWeAreMenu: (
  careersUrl: string,
  planYourJourneyUrl: string,
  companyUrl: string
) => { label: string; path: string; internal: boolean }[] = (careersUrl, planYourJourneyUrl, companyUrl) => [
  {
    label: 'About us',
    path: companyUrl,
    internal: false,
  },
  {
    label: 'Careers',
    path: careersUrl,
    internal: false,
  },
  {
    label: 'Plan your journey',
    path: planYourJourneyUrl,
    internal: false,
  },
];

export const blogMenu: () => MenuItem[] = () => [
  {
    label: 'Archive',
    path: '/archive/',
    internal: true,
  },
  {
    label: 'Authors',
    path: '/authors/',
    internal: true,
  },
];

export const techMenu: (techRadarPath: string) => MenuItem[] = (techRadarPath) => [
  {
    label: 'Overview',
    path: '/our-tech-ecosystem/',
    internal: true,
  },
  {
    label: 'Tech Radar',
    path: techRadarPath,
    internal: true,
  },
];
